import { useState } from "react";
import { ChatKit, useChatKit } from "@openai/chatkit-react";
import { Box, Button, styled, useTheme } from "@mui/material";
import { configuration } from "../configuration";
import { useAccessToken } from "../http";
import { AIIcon } from "src/assets/icons/AIIcon";
import { AICloseIcon } from "src/assets/icons/AICloseIcon";
import { useBreakpoints } from "src/hooks";

const MobileNavButton = styled(Button)`
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.primary.main};
  border-radius: 50%;
  position: fixed;
  bottom: 40px;
  right: 40px;
  width: 60px;
  min-width: 60px;
  height: 60px;
  padding: 0;
  z-index: 5;
`;

export function ChatBot() {
  const { getAccessToken } = useAccessToken();
  const [isOpen, setIsOpen] = useState(false);
  const { isMdUp } = useBreakpoints();
  const theme = useTheme();

  const { control } = useChatKit({
    api: {
      async getClientSecret(existing) {
        if (existing) {
          // implement session refresh
        }

        const accessToken = await getAccessToken();

        // Generate a unique device ID (you can customize this based on your needs)
        const deviceId = `device_${Date.now()}`;

        const res = await fetch(`${configuration.apiRootUrl}/mcp/chatkit/session`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            workflowId: configuration.chatkitWorkflowId,
            deviceId: deviceId,
          }),
        });

        const { clientSecret } = await res.json();
        return clientSecret;
      },
    },
  });

  return (
    <>
      {/* Chat Window */}
      <Box
        sx={{
          position: "fixed",
          bottom: 120,
          right: 20,
          zIndex: 1000,
          backgroundColor: "#ffffff",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          borderRadius: "8px",
          overflow: "hidden",
          display: isOpen ? "block" : "none",
          height: "600px",
          width: "320px",
        }}
      >
        <ChatKit control={control} style={{ height: "100%", width: "100%" }} />
      </Box>

      <MobileNavButton
        variant="contained"
        sx={{ display: !isMdUp ? "none" : "flex" }}
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
      >
        {isOpen ? (
          <AICloseIcon style={{ fill: theme.palette.grey[400], height: 40, width: 40 }} viewBox="0 0 40 40" />
        ) : (
          <AIIcon style={{ fill: theme.palette.grey[400], height: 40, width: 40 }} viewBox="0 0 40 40" />
        )}
      </MobileNavButton>
    </>
  );
}
